import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import mediaPlaceholder from "../../../Common/_assets/img/placeholder/photo-placeholder.png";
import mediaPlaceholderPortrait from "../../../Common/_assets/img/placeholder/spacer_portrait_press.png";
import mediaPlaceholderSquare from "../../../Common/_assets/img/placeholder/spacer_square.gif";

import TitleMediaMp3Single from "./Audio/TitleMediaMp3Single";
import AlbumModal from "./AlbumModal";
import scriptPlaceholder from "../../../Common/_assets/img/bg/script-blank.png";
// import ReactGA from "react-ga4";

const TitleMediaItem = ({
	mediaItem,
	categorySlug,
	titleSlug,
	titleName,
	mediaSection,
}) => {
	const s3Url = "https://jwlfyc-public-us-east-1.s3.amazonaws.com/";

	const location = useLocation();

	const [thumbnail, setThumbnail] = useState(null),
		[description, setDescription] = useState(null),
		[slug, setSlug] = useState(null),
		[title, setTitle] = useState(null),
		[subTitle, setSubtitle] = useState(null),
		[showAlbumModal, setShowAlbumModal] = useState(false),
		[imgOrientation, setImgOrientation] = useState("landscape");

	useEffect(() => {
		let subscribed = true;
		if (subscribed && mediaItem) {
			// console.log("media", mediaSection, mediaItem);
			let slugPrefix =
				"/" + categorySlug + "/" + titleSlug + "/" + mediaSection + "/";
			if (location.pathname.includes("/pga")) {
				if (mediaSection === "press") {
					if (mediaItem.type === "youtube") {
						if (mediaItem.thumbnail) {
							setThumbnail(s3Url + mediaItem.thumbnail);
						} else {
							setThumbnail(
								"https://i.ytimg.com/vi/" +
									mediaItem.filename +
									"/maxresdefault.jpg",
							);
						}
						setSlug("/pga" + slugPrefix + mediaItem.slug);
					} else if (mediaItem.type.includes("pdf")) {
						setThumbnail(s3Url + mediaItem.thumbnail);
						setSlug("/pga" + slugPrefix + mediaItem.slug);
					} else {
						setThumbnail(s3Url + mediaItem.filename);
						setSlug(mediaItem.url);
					}
				} else if (mediaSection === "scripts") {
					setThumbnail(scriptPlaceholder);
					setSlug("/pga" + slugPrefix + mediaItem.slug);
				} else {
					if (mediaItem.thumbnail) {
						setThumbnail(s3Url + mediaItem.thumbnail);
					} else {
						setThumbnail(
							"https://i.ytimg.com/vi/" +
								mediaItem.filename +
								"/maxresdefault.jpg",
						);
					}
					setSlug("/pga" + slugPrefix + mediaItem.slug);
				}
				// } else if (location.pathname.includes("/ves")) {
				// 	if (mediaSection === "press") {
				// 		if (mediaItem.type === "youtube") {
				// 			if (mediaItem.thumbnail) {
				// 				setThumbnail(s3Url + mediaItem.thumbnail);
				// 			} else {
				// 				setThumbnail(
				// 					"https://i.ytimg.com/vi/" +
				// 						mediaItem.filename +
				// 						"/maxresdefault.jpg",
				// 				);
				// 			}
				// 			setSlug("/ves" + slugPrefix + mediaItem.slug);
				// 		} else if (mediaItem.type.includes("pdf")) {
				// 			setThumbnail(s3Url + mediaItem.thumbnail);
				// 			setSlug("/ves" + slugPrefix + mediaItem.slug);
				// 		} else {
				// 			setThumbnail(s3Url + mediaItem.filename);
				// 			setSlug(mediaItem.url);
				// 		}
				// 	} else if (mediaSection === "scripts") {
				// 		setThumbnail(scriptPlaceholder);
				// 		setSlug("/ves" + slugPrefix + mediaItem.slug);
				// 	} else {
				// 		if (mediaItem.thumbnail) {
				// 			setThumbnail(s3Url + mediaItem.thumbnail);
				// 		} else {
				// 			setThumbnail(
				// 				"https://i.ytimg.com/vi/" +
				// 					mediaItem.filename +
				// 					"/maxresdefault.jpg",
				// 			);
				// 		}
				// 		setSlug("/ves" + slugPrefix + mediaItem.slug);
				// 	}
			} else {
				if (mediaSection === "press") {
					if (mediaItem.type === "youtube") {
						if (mediaItem.thumbnail) {
							setThumbnail(s3Url + mediaItem.thumbnail);
						} else {
							setThumbnail(
								"https://i.ytimg.com/vi/" +
									mediaItem.filename +
									"/maxresdefault.jpg",
							);
						}
						setSlug(slugPrefix + mediaItem.slug);
					} else if (mediaItem.type.includes("pdf")) {
						(async () => {
							try {
								const o = await getImageOrientation(
									s3Url + mediaItem.thumbnail,
								);
								setImgOrientation(o);
							} catch (e) {
								console.error(e);
							}
						})();
						setThumbnail(s3Url + mediaItem.thumbnail);
						setSlug(slugPrefix + mediaItem.slug);
					} else {
						if (mediaItem.filename) {
							(async () => {
								try {
									const o = await getImageOrientation(
										s3Url + mediaItem.filename,
									);
									setImgOrientation(o);
									// console.log(s3Url + mediaItem.filename, o);
								} catch (e) {
									console.error(e);
								}
							})();
							setThumbnail(s3Url + mediaItem.filename);
						}

						setSlug(mediaItem.url);
						const st = getRootDomain(mediaItem.url);
						setSubtitle(st);
					}
				} else if (mediaSection === "scripts") {
					setThumbnail(scriptPlaceholder);
					setSlug(slugPrefix + mediaItem.slug);
				} else if (mediaSection === "galleries") {
					setThumbnail(s3Url + mediaItem.media[0].filename);
					setSlug(slugPrefix + mediaItem.slug);
				} else {
					if (mediaItem.thumbnail) {
						setThumbnail(s3Url + mediaItem.thumbnail);
					} else {
						setThumbnail(
							"//i.ytimg.com/vi/" +
								mediaItem.filename +
								"/maxresdefault.jpg",
						);
					}
					setSlug(slugPrefix + mediaItem.slug);
				}
			}

			if (mediaSection === "press") {
				setDescription(
					mediaItem.description
						? truncate(mediaItem.description, 200)
						: "",
				);
			} else {
				setDescription(
					mediaItem.description
						? truncate(mediaItem.description, 130)
						: "",
				);
			}

			setTitle(mediaItem.title);
		}
		return () => {
			subscribed = false;
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [mediaItem, categorySlug, titleSlug, mediaSection]);

	const getRootDomain = (url) => {
		try {
			const { hostname } = new URL(url);
			const cleanHost = hostname.replace(/^www\./, "");
			const parts = cleanHost.split(".");
			if (parts.length > 2) {
				return parts.slice(-2).join(".");
			}
			return cleanHost;
		} catch (err) {
			console.error("Invalid URL:", url);
			return null;
		}
	};

	const truncate = (input, length) => {
		if (input.length > 5) {
			return input.substring(0, length) + "...";
		}
		return input;
	};

	const getImageOrientation = (url) =>
		new Promise((resolve, reject) => {
			const img = new Image();
			img.onload = () => {
				const w = img.naturalWidth,
					h = img.naturalHeight;
				resolve(w > h ? "landscape" : w < h ? "portrait" : "square");
			};
			img.onerror = () => reject(new Error("Failed to load image"));
			img.src = url;
			// console.log(img);
		});

	// const formatGAEventName = (str1, str2) => {
	// 	const maxTotalLength = 39; // total chars excluding the pipe
	// 	const maxStr1Length = 19;
	//
	// 	let truncatedStr1 = str1.slice(0, maxStr1Length);
	// 	let remainingLength = maxTotalLength - truncatedStr1.length;
	// 	let truncatedStr2 = str2.slice(0, remainingLength);
	//
	// 	return `${truncatedStr1}|${truncatedStr2}`;
	// };

	if (mediaSection === "galleries") {
		return (
			<div className={"col-12 col-md-4 mb-3"}>
				<div className={"pe-0 pe-md-4"}>
					<a
						href={"/"}
						rel="noopener noreferrer"
						className="titledetail__mediaitem d-block"
						onClick={(e) => {
							e.preventDefault();
							setShowAlbumModal(true);
						}}
					>
						<div
							className="titledetail__mediaitem--thumbnail-container"
							style={{
								backgroundImage: 'url("' + thumbnail + '")',
								backgroundSize: "cover",
								backgroundPosition: "center center",
								backgroundRepeat: "no-repeat",
							}}
						>
							<img
								src={mediaPlaceholder}
								alt={title}
								className=""
							/>
						</div>
						<div
							className={
								"d-block mb-1 titledetail__mediaitem--title " +
								(mediaSection === "scripts"
									? "text-center"
									: "")
							}
						>
							{title}
						</div>
					</a>
				</div>
				<AlbumModal
					title={mediaItem.title}
					albumMedia={mediaItem.media}
					setShowAlbumModal={setShowAlbumModal}
					showAlbumModal={showAlbumModal}
				/>
			</div>
		);
	} else if (mediaSection === "audio" && mediaItem.type === "audio/mpeg") {
		return (
			<div className={"col-12 mb-3"}>
				<TitleMediaMp3Single track={mediaItem} />
			</div>
		);
	} else if (mediaSection === "audio" && mediaItem.type.includes("spotify")) {
		const spotifyType = mediaItem.type.split("/")[1];
		return (
			<div className={"col-12 mb-3"}>
				<iframe
					title={mediaItem.title}
					style={{ borderRadius: "12px" }}
					src={
						"https://open.spotify.com/embed/" +
						spotifyType +
						"/" +
						mediaItem.filename +
						"?utm_source=generator"
					}
					width="100%"
					height="152"
					allowFullScreen=""
					allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
					loading="lazy"
				></iframe>
			</div>
		);
	} else if (mediaSection === "press") {
		return (
			<div
				className={"col-12 mb-3 p-2 p-sm-3"}
				style={{
					backgroundColor: "rgba(255,255,255,.05)",
					borderRadius: "3px",
				}}
			>
				<div className={""}>
					<a
						href={slug}
						rel="noopener noreferrer"
						className="titledetail__mediaitem d-flex"
						style={{ lineHeight: "1.3em", fontSize: ".9em" }}
					>
						<div className={"flex-grow-1 pe-3"}>
							<div className={"mb-2 fw-bold"}>{title}</div>
							{subTitle ? (
								<div className={"mb-2"}>
									<div
										className={"d-inline-block py-1 px-2"}
										style={{
											opacity: 1,
											fontStyle: "italic",
											borderRadius: "3px",
											backgroundColor:
												"rgba(255,255,255,.1)",
										}}
									>
										{subTitle}
									</div>
								</div>
							) : (
								<></>
							)}
							<div
								style={{
									opacity: 0.75,
								}}
								dangerouslySetInnerHTML={{
									__html: description,
								}}
							/>
						</div>
						{thumbnail ? (
							<div className={"flex-shrink-0"}>
								<div
									className="titledetail__mediaitem--thumbnail-container"
									style={{
										backgroundImage:
											'url("' + thumbnail + '")',
										backgroundSize:
											imgOrientation === "landscape"
												? "cover"
												: "contain",
										backgroundPosition: "center right",
										backgroundRepeat: "no-repeat",
									}}
								>
									<img
										src={
											imgOrientation === "landscape"
												? mediaPlaceholder
												: imgOrientation === "portrait"
													? mediaPlaceholderPortrait
													: imgOrientation ===
														  "square"
														? mediaPlaceholderSquare
														: mediaPlaceholder
										}
										alt={title}
										className="titledetail__mediaitem--placeholder"
										style={{ maxHeight: 140 }}
									/>
								</div>
							</div>
						) : (
							<></>
						)}
					</a>
				</div>
			</div>
		);
	} else {
		return (
			<div className={"col-12 col-md-4 mb-3"}>
				<div className={"pe-0 pe-md-4"}>
					<a
						href={slug}
						rel="noopener noreferrer"
						className="titledetail__mediaitem d-block"
						// onClick={() => {
						// 	const gaAction = formatGAEventName(
						// 		titleSlug,
						// 		title,
						// 	);
						// 	console.log(gaAction);
						// 	ReactGA.event({
						// 		category: "Title Page Media View",
						// 		action: gaAction,
						// 		label: titleSlug,
						// 	});
						// }}
					>
						<div
							className="titledetail__mediaitem--thumbnail-container"
							style={{
								backgroundImage: 'url("' + thumbnail + '")',
								backgroundSize:
									mediaSection === "press" ||
									mediaSection === "scripts"
										? "contain"
										: "cover",
								backgroundPosition:
									mediaSection === "press"
										? "center bottom"
										: "center center",
								backgroundRepeat: "no-repeat",
							}}
						>
							<img
								src={mediaPlaceholder}
								alt={title}
								className="titledetail__mediaitem--placeholder"
							/>
						</div>
						<div
							className={
								"d-block  mb-1 titledetail__mediaitem--title " +
								(mediaSection === "scripts"
									? "text-center"
									: "")
							}
						>
							{title}
						</div>
						<div
							className="d-block mb-2 titledetail__mediaitem--description"
							dangerouslySetInnerHTML={{ __html: description }}
						/>
					</a>
				</div>
			</div>
		);
	}
};

export default TitleMediaItem;
